import React from 'react'
import { Maximize2 } from 'lucide-react'

/**
 * Fit to Page Button Component
 * Reusable button that fits any element to the full page dimensions
 */
const FitToPageButton = ({
  selectedElement,
  updateElementProperty,
  currentPage,
  element
}) => {
  const handleFitToPage = () => {
    if (!selectedElement || !currentPage || !element) return

    // Get page dimensions
    const pageWidth = currentPage.page_config?.width || 800
    const pageHeight = currentPage.page_config?.height || 600

    // Special handling for freehand elements
    if (element.type === 'freehand' && element.pathData) {
      // Get current element dimensions
      const currentWidth = element.width || 100
      const currentHeight = element.height || 100

      // Calculate scale factors
      const scaleX = pageWidth / currentWidth
      const scaleY = pageHeight / currentHeight

      // Scale the pathData nodes
      const scaledPathData = {
        ...element.pathData,
        nodes: element.pathData.nodes?.map(node => ({
          ...node,
          p: {
            x: node.p.x * scaleX,
            y: node.p.y * scaleY
          },
          // Scale control handles if they exist
          h1: node.h1 ? {
            x: node.h1.x * scaleX,
            y: node.h1.y * scaleY
          } : undefined,
          h2: node.h2 ? {
            x: node.h2.x * scaleX,
            y: node.h2.y * scaleY
          } : undefined
        })) || []
      }

      // Update element with scaled pathData and new dimensions
      updateElementProperty(selectedElement, 'x', 0)
      updateElementProperty(selectedElement, 'y', 0)
      updateElementProperty(selectedElement, 'width', pageWidth)
      updateElementProperty(selectedElement, 'height', pageHeight)
      updateElementProperty(selectedElement, 'pathData', scaledPathData)
    } else {
      // Standard handling for other element types
      updateElementProperty(selectedElement, 'x', 0)
      updateElementProperty(selectedElement, 'y', 0)
      updateElementProperty(selectedElement, 'width', pageWidth)
      updateElementProperty(selectedElement, 'height', pageHeight)
    }
  }

  return (
    <button
      onClick={handleFitToPage}
      className="flex items-center justify-center gap-2 w-full bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
      title="Fit element to page dimensions (x=0, y=0, width=page width, height=page height)"
    >
      <Maximize2 className="w-4 h-4" />
      Fit to Page
    </button>
  )
}

export default FitToPageButton
